
import { login, loginOut } from '@/api/interface/user'
const app = {
  state: {
    userInfo: null,
    isMobile: false,
    timeDiff: 0,
    uploadParams: null,
    device: null,
    cityName: null, // 所在城市
    longitude: null, // 用户所在纬度
    latitude: null, // 用户所在经度
    publishStatus: 0,
    shareTitle: {},
    shareList: {
      indexM: '2024年四季“村晚”示范展示活动',
      indexF: '振兴乡村文化，唱响美好生活',
      newsM: '2024年四季“村晚”示范展示活动·活动快讯',
      newsF: '村晚”新鲜事',
      newsDetail: '2024年四季“村晚”示范展示活动·活动快讯',
      sjcwlistM: '2024年四季“村晚”示范展示活动专栏',
      sjcwlistF: '春夏秋冬，四季纷呈',
      sjcwDetail: '2024年四季“村晚”示范展示活动精彩直播',
      zacwlistM: '2024年四季“村晚”示范展示活动·我最爱的村晚节目',
      zacwlistF: '快来pick你最爱的村晚节目吧~',
      zajmDetail: '2024年四季“村晚”示范展示活动·我最爱的村晚节目',
      dnkcM: '2024年四季“村晚”示范展示活动·带你看村晚',
      dnkcwF: '玩转村晚，图文特辑',
      dnkcwDetail: '2024年四季“村晚”示范展示活动·带你看村晚',
      wlzqM: '2024年四季“村晚”示范展示活动·文旅专区',
      wlzqF: '村晚小百科·村里好风光·文创小商店',
      wlrlM: '2024年四季“村晚”示范展示活动活动日历',
      wlrlF: '锁定活动日程，掌握最新动态',
      xcwhlistF: '',
      resultM: '',
      resultF: '',
      myEyesM:'2024年四季“村晚”示范展示活动·我眼中的村晚',
      myEyesF: '我眼中的村晚',
      imgUrl: require('../../assets/img/shareicon.png'),
      videoUrl: 'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/宣传片/1-四季村晚.mp4',
      coverUrl:'https://lbcdn.kadadx.com/file/陕西省文化馆/2024享活动/宣传片/1-四季村晚.png'
      

    },
    operate: {
      news: '5a87513e-f24f-46cf-a390-000450cb641f-news',//	大地欢歌-四季村晚	大地欢歌-四季村晚--图文
      likeHistory: '5a87513e-f24f-46cf-a390-000450cb641f-like-history',//	大地欢歌-四季村晚	大地欢歌-四季村晚-地方风采
      like23: '5a87513e-f24f-46cf-a390-000450cb641f-like-2023',//	大地欢歌-四季村晚	大地欢歌-四季村晚2023节目评选
      tidbits: '5a87513e-f24f-46cf-a390-000450cb641f-tidbits',//	大地欢歌-四季村晚	大地欢歌-四季村晚花絮
      star: '5a87513e-f24f-46cf-a390-000450cb641f-star',//乡村网红
      eye:'5a87513e-f24f-46cf-a390-000450cb641f-eye',//2024-大地欢歌-四季村晚	大地欢歌-四季村晚-我眼中的村晚
	    point:'5a87513e-f24f-46cf-a390-000450cb641f-point',//2024-大地欢歌-四季村晚	大地欢歌-四季村晚-示范点风采
	
    },
    infoList: {
      sjcw: '为深入学习宣传贯彻党的二十大精神、全面推进乡村文化振兴、推动公共文化服务高质量发展，特此开展“四季村晚”活动。通过开展春季、夏季、秋季、冬季“村晚”活动，推动“村晚”活动常态化开展，展示各地乡村丰富多彩群众文化活动，呈现乡村振兴的丰硕成果，促进文旅融合，推进移风易俗，树立文明乡风，激发新时代乡村振兴的文化活力。',
      zajm1: '陕西省文化馆“四季村晚”系列活动之“我最爱的村晚节目”，精选一批陕西省近年来农民群众自编自导自演的“村晚”精彩节目，展开线上展示及点赞。',
      zajm2: '同时，针对2024年度短视频征集，开展线上网络点赞，最终推选出10个优秀节目并发布榜单，在主流媒体进行宣推，并收录至全民艺术普及资源总库。快来一键参与，为你最喜爱的“村晚”节目助力吧！',
      zajm3: '1、点赞时段：待2024年短视频征集后集中发起；',
      zajm4: '2、每个用户可为多个短视频作品点赞；',
      zajm5: '3、每个用户每天对同一作品可点赞5次。',
      dnkcw1: '家门口的大联欢！',
      dnkcw2: '带你探寻“村晚”节目背后的故事，浓浓家乡味，美丽新乡村。',
      dnkcw3: '多维呈现村晚故事，感受村晚现场氛围。',
      wlzq1: '将村里的故事讲给你听。',
      wlzq2: '倾听文旅小故事，领略文旅好风光。',
      wlzq3: '融合乡土文化、乡村旅游，呈现农民精神新风貌、乡村振兴新气象。', 
      wyzdcw:'群众故事群众说。记录大家眼中的村晚精彩。'
    },
    fourList: [],
    ewmList: [
      { title: '微信公众号', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/wx.png'), ewm: require('../../assets/img/wx.jpg') },
      { title: '视频号', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/sph.png'), ewm: require('../../assets/img/sph.jpg')  },
      { title: '官方微博', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/wb.png'), ewm: require('../../assets/img/wb.png') },
      { title: 'bilibili 哔哩哔哩', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/B.png'), ewm: require('../../assets/img/bz.png') },
      { title: '官方抖音', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/dy.png'), ewm: require('../../assets/img/dy.jpg') },
      // { title: '快手（认证中）', unit: '陕西省文化馆', cover: require('../../assets/img/sjcw/ks.png'), ewm: null },
    ],
    youList: [
      { cover: require('../../assets/img/sjcw/logo1.png'), path: 'http://whhlyt.shaanxi.gov.cn/' },
      { cover: require('../../assets/img/sjcw/logo2.png'), path: 'http://sxswhg.org.cn/' },
      { cover: require('../../assets/img/sjcw/logo3.png'), path: 'http://www.sxggwhy.com/' },
    ],
     villageList: [
        {name:'北冯村',value:1},
        {name:'肖家坝村',value:2},
        {name:'营梁村' ,value:3},
        {name:'镇东村' ,value:4},
        {name:'高家堡村' ,value:5},
        {name:'汤峪村' ,value:6},
        {name:'印象圪崂村' ,value:7},
        {name:'郝家桥村' ,value:8},
        {name:'朱家湾村' ,value:9},
        {name:'上王村' ,value:10},
        {name:'庆丰村' ,value:11},
        {name:'中坝村',value:12} 
      ],

provinceList:[
  {name:'李家槽岭村',value:1001},
  {name:'永乐村',value:2001},
  {name:'棋盘村' ,value:3001},
  {name:'樊家川村' ,value:4001},
  {name:'堰口社区' ,value:5001},
  {name:'罗寨村' ,value:6001},
  {name:'大樊村' ,value:7001},
  {name:'刘家川村' ,value:8001},
  {name:'许家城村' ,value:9001},
  {name:'阳光社区' ,value:10001},
  {name:'庙西村' ,value:11001},
  {name:'青坪村',value:12001} ,
  {name:'阴湾村',value:13001} ,
  {name:'五四村',value:14001} ,
  {name:'枞岭村',value:15001} ,
  {name:'蔡家坡村',value:16001} ,
  {name:'马咀村',value:17001} ,
  {name:'党家店村',value:18001} ,
  {name:'蜀河社区',value:19001} ,
  {name:'书院社区',value:20001} ,
]
  },

  mutations: {
    SET_FOURLIST: (state, fourList) => {
      state.fourList = fourList
    },
    SET_PUBLISHOVER: (state, publishStatus) => {
      state.publishStatus = publishStatus
    },
    SET_SHARELIST: (state, shareList) => {
      state.shareList = shareList
    },
    SET_SHARETITLE: (state, shareTitle) => {
      state.shareTitle = shareTitle
    },
    SET_OPERATECODE: (state, operateCode) => {
      state.operateCode = operateCode
    },
    SET_DEVICE: (state, device) => {
      state.device = device
    },
    SET_POSITION: (state, position) => {
      state.position.latitude = position.latitude
      state.position.longitude = position.longitude
    },
    SET_CITY: (state, cityName) => {
      state.cityName = cityName
    },
    SET_LONGITUDE: (state, longitude) => {
      state.longitude = longitude
    },
    SET_LATITUDE: (state, latitude) => {
      state.latitude = latitude
    },
    SET_MAPDATA: (state, obj) => {
      state.cityName = obj.city
      state.longitude = obj.bounds.northeast.lng
      state.latitude = obj.bounds.northeast.lat
      state.latitude = obj.bounds.northeast.lat
    },
    SET_UPLOADPARAMS: (state, uploadParams) => {
      state.uploadParams = uploadParams
    },
    SET_ISMOBILE: (state, isMobile) => {
      state.isMobile = isMobile
    },
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo
    },
    SET_USERINFOLOGIN: (state, userinfologin) => {
      state.userinfologin = userinfologin
    },
    SET_SYSTIME: (state, timeDiff) => {
      state.timeDiff = timeDiff
    }
  },
  actions: {
    // 用户登录
    login({ commit }, userInfo) {
      const { userCode, password } = userInfo
      return new Promise((resolve, reject) => {
        login({ userCode: userCode.trim(), password: password }).then(response => {
          const { data } = response
          commit('SET_USERINFOLOGIN', response.data.data.list[0].user)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户登出
    loginOut({ commit }) {
      return new Promise((resolve, reject) => {
        loginOut().then(res => {
          commit('SET_USERINFOLOGIN', null)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js